module.exports = __webpack_public_path__ + "static/media/pencil-line.94a8312b.svg";